import React from 'react';

const Impersonate = ({ color = '#8C949C', ...props }) => (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M8 16.038c1.664 0 5 .967 5 2.894v.376c0-1.576 2.669-2.368 4-2.368s4 .792 4 2.368V21H3v-2.068c0-1.927 3.336-2.894 5-2.894zM17.143 12c1.186 0 2.136.907 2.136 2.03 0 1.123-.95 2.03-2.136 2.03-1.186 0-2.143-.907-2.143-2.03 0-1.123.957-2.03 2.143-2.03zm-8.964-2c1.482 0 2.67 1.108 2.67 2.481 0 1.373-1.188 2.481-2.67 2.481-1.483 0-2.679-1.108-2.679-2.48C5.5 11.107 6.696 10 8.179 10zM18 3v4h2l-3 4-3-4h2V5H9v3H7V3h11z"
            fill={color}
            fillRule="evenodd"
        />
    </svg>
);
export default Impersonate;
